import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import Heading from '../elements/PageHeading';
import Paragraph from '../elements/Paragraph';
import Check from '../../assets/check';

const Wrapper = styled.div`
  fill: ${props => props.theme.success};
  text-align: right;
  padding-right: 125px;
  margin-top: 46px;
`;

const SuccessPage = ({ t, message }) => (
  <React.Fragment>
    <Heading id="success_header" text={t('messages.thank_you')} />
    <Paragraph topMargin={12}>{t(message)}</Paragraph>
    <Wrapper>
      <Check />
    </Wrapper>
  </React.Fragment>
);

export default translate()(SuccessPage);
